import { Chip, makeStyles } from '@material-ui/core'
import { StatusIntegracaoProgramacao, statusIntegracaoColor } from './types'

interface SetBadgeColorProps {
  status: Exclude<StatusIntegracaoProgramacao, ''>
  marginLeft?: string
}

const statusIntegracaoLabel: Record<
  Exclude<StatusIntegracaoProgramacao, ''>,
  string
> = {
  AGUARDANDO: 'Aguardando',
  ERRO: 'Erro',
  INTEGRADO: 'Integrado',
  CANCELADO: 'Cancelado'
}

const useStyles = makeStyles(theme => ({
  customBadge: (props: SetBadgeColorProps) => ({
    backgroundColor: statusIntegracaoColor[props.status],
    width: 96,
    color: theme.palette.getContrastText(statusIntegracaoColor[props.status]),
    marginLeft: props.marginLeft || 0
  })
}))

function StatusIntegracaoBadge(props: SetBadgeColorProps) {
  const classes = useStyles(props)

  return (
    <Chip
      label={statusIntegracaoLabel[props.status] || props.status}
      size="small"
      variant="default"
      className={classes.customBadge}
    />
  )
}

export default StatusIntegracaoBadge
